
import { UserPermissions } from '../models';

export function hasPermission(haystack: string[] | undefined | null, needle: string): boolean {
    if (!haystack || haystack.length === 0) {
        return false;
    }

    const lowerCaseNeedle = needle.trim().toLowerCase();
    const isFoundations = lowerCaseNeedle === UserPermissions.Foundations.toLowerCase();

    return haystack.some(p => {
        const lowerCaseP = p.trim().toLowerCase();
        if (lowerCaseP === lowerCaseNeedle) {
            return true;
        }
        if (isFoundations && lowerCaseP === 'limitedreport') {
            return true;
        }
        return false;
    });
}
export function removePermission(permissions: string[], permission: string) {
    return permissions.filter(p => p.trim().toLowerCase() !== permission.trim().toLowerCase());
}
export function addPermission(permissions: string[], permission: string): string[] {
    if (hasPermission(permissions, permission)) {
        return permissions;
    }
    return [...permissions, permission];
}
export function togglePermission(permissions: string[], permission: string): string[] {
    if (hasPermission(permissions, permission)) {
        return removePermission(permissions, permission);
    }
    return addPermission(permissions, permission);
}



// WEBPACK FOOTER //
// ./src/utilities/User.ts